"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");
/**
 * A comunica Query Operation Actor for BGPs with a single pattern.
 */


var ActorQueryOperationBgpSingle =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationBgpSingle, _bus_query_operation_);

  function ActorQueryOperationBgpSingle(args) {
    _classCallCheck(this, ActorQueryOperationBgpSingle);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationBgpSingle).call(this, args, 'bgp'));
  }

  _createClass(ActorQueryOperationBgpSingle, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(pattern.patterns.length !== 1)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Actor ' + this.name + ' can only operate on BGPs with a single pattern.');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function runOperation(pattern, context) {
      // If we have parent metadata, extract the single parent metadata entry.
      if (context && context.has(bus_query_operation_1.KEY_CONTEXT_BGP_PARENTMETADATA)) {
        var metadatas = context.get(bus_query_operation_1.KEY_CONTEXT_BGP_PARENTMETADATA);
        context = context.delete(bus_query_operation_1.KEY_CONTEXT_BGP_PARENTMETADATA);
        context = context.set(bus_query_operation_1.KEY_CONTEXT_PATTERN_PARENTMETADATA, metadatas[0]);
      }

      return this.mediatorQueryOperation.mediate({
        operation: pattern.patterns[0],
        context: context
      });
    }
  }]);

  return ActorQueryOperationBgpSingle;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationBgpSingle = ActorQueryOperationBgpSingle;